import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EthicCheckLanding from './components/EthicCheckLanding';
import MethodologyPage from './components/MethodologyPage';
import DisclaimerPage from './components/DisclaimerPage';
import PrivacyPage from './components/PrivacyPage';
import SecurityPage from './components/SecurityPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<EthicCheckLanding />} />
        <Route path="/methodology" element={<MethodologyPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/security" element={<SecurityPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
